import { DataService } from 'src/app/services/data.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DocumentToBeDeleted } from 'src/app/models/internal/document-tobe-deleted';
@Component({
  selector: 'app-documentcontainer',
  templateUrl: './documentcontainer.component.html',
  styleUrls: ['./documentcontainer.component.scss']
})
export class DocumentcontainerComponent implements OnInit {
  @Input() url: string;
  @Input() fileName: string;
  @Input() id: number;
  @Input() type: number;
  @Input() showHeader: boolean;
  @Input() showDelete: boolean;
  @Output() private documentDeleteClicked: EventEmitter<DocumentToBeDeleted> = new EventEmitter<DocumentToBeDeleted>();

  constructor( public dataService: DataService) {
    console.debug('document id', this.id);
  }

  ngOnInit() {
  }

  deleteDocument()
  {
    const documentToBeDeleted: DocumentToBeDeleted = {
      Id: this.id,
      FileName: this.fileName,
      Url: this.url
    }
    this.documentDeleteClicked.emit(documentToBeDeleted);
  }

  viewDocument()
  {
    if (this.type == 99) // 99 => reserved  to indicate info button document
    {
      this.dataService.getInfoDocumentFile(this.id.toString()).subscribe((response: any) =>{
        this.download(response['Data']['Base64String'], response['Data']['FileName'], "application/pdf");
      });
    }
    else
    {
      //window.open(this.url, '_blank');
      this.dataService.getDocumentFile(this.id.toString()).subscribe((response: any) =>{
        this.download(response['Data']['Base64String'], response['Data']['FileName'], "application/octet-stream;base64");
      });
    }

  }
  close()
  {
    var modal = document.getElementById('myModal');
    modal.style.display = "none";
  }

  b64toBlob = (b64Data, contentType='', sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
      
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  download(data, filename, type) {
    var file = this.b64toBlob(data, type);
    if (window.navigator.msSaveOrOpenBlob) // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
    else { // Others
        var a = document.createElement("a"),
                url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, 0);
    }
}

}

